export const colors = {
  brand: {
    1: '#006983',
    2: '#D56E35',
    3: '#E6F0F2',
    4: '#FFFFFF',
  },
  background: {
    page: {
      light: '#FFFFFF',
      pale: '#F5F0EB',
    },
    section: {
      median: '#11819D',
      dark: '#25505C',
      darker: '#183840',
    },
    component: {
      default: '#006983',
      cta: '#D56E35',
      subtle: '#E6F0F2',
      ctaInverse: '#FFFFFF',
      ctaHover: '#006983',
      ctaInverseHover: '#C3E6E9',
      neutral: '#FFFFFF',
      neutalInverse: '#FFFFFF00',
      neutralHover: '#006983',
      neutralSubtleHover: '#E6F0F2',
      neutralInverseHover: '#FFFFFF33',
      input: '#FFFFFF',
      inputInverse: '#FFFFFF',
      inputDisabled: '#0000000C',
      inputDisabledInverse: '#FFFFFF33',
      disabled: '#00000019',
      disabledInverse: '#FFFFFF33',
      carouselButton: '#D9D9D966',
      carouselButtonHover: '#D9D9D9',
      campaignLabel: '#CF3636',
    },
  },
  border: {
    default: '#E6F0F2',
    inverse: '#FFFFFF',
    focus: '#33879C',
    focusInverse: '#C3E6E9',
    input: '#898989',
    inputInverse: '#FFFFFF',
    inputHover: '#11819D',
    inputInverseHover: '#FFFFFF',
    link: '#D56E35',
    linkInverse: '#FFFFFF',
    linkHover: '#006983',
    linkInverseHover: '#C3E6E9',
    hyperlink: '#006983',
    hyperlinkInverse: '#FFFFFF',
    neutral: '#11819D',
    neutralInverse: '#E6F0F2',
    controlHover: '#00698319',
    controlInverseHover: '#FFFFFF19',
    labelTag: '#0078DC ',
    appropriationLabel: '#2C879E',
    campaignLabel: '#CF3636',
  },
  text: {
    default: '#143344',
    inverse: '#FFFFFF',
    heading: '#006983',
    blackHeading: '#000000',
    link: '#006983',
    linkInverse: '#FFFFFF',
    linkHover: '#25505C',
    linkInverseHover: '#C3E6E9',
    input: '#006983',
    placeholder: '#767676',
    inputDisabled: '#00000059',
    inputDisabledInverse: '#FFFFFF7F',
    disabled: '#00000059',
    disabledInverse: '#FFFFFF7F',
    labelText: '#0078DC',
    appropriationLabelText: '#2C879E',
    titleSection: '#2C879E',
    campaignPrice: '#CF3636',
  },
  feedback: {
    informational: '#0078DC',
    success: '#008C00',
    warning: '#E65A00',
    error: '#EB0000',
    errorInverse: '#FFCBBC',
    informationalBackground: '#CCE4F8',
    successBackground: '#CCE8CC',
    warningBackground: '#FADECC',
    errorBackground: '#FBCCCC',
  },
}
